<template>
	<div style="padding: 20px">
		<div class="Section0" style="layout-grid:15.6000pt;">
		<p class=MsoNormal align=center style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:center;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:18.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">众诚保险公众号</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:18.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">个人信息保护政策</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:18.0000pt;mso-font-kerning:0.0000pt;"><br></span></b><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;"><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<font face="宋体">更新日期：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">2022年3月2日</span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<font face="宋体">版本日期：</font>
				<font face="宋体">2</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">022</span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<font face="宋体">年</font>
				<font face="宋体">3月2日</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;mso-bidi-font-weight:bold;
font-size:11.0000pt;mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">众诚汽车保险股份有限公司</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">（以下简称</font>“
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">众诚保险</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">”或“我们”）</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">充分</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">尊重您的个人信息权利并且深知遵循合法、正当、必要和诚信原则处理您的个人信息的重要性。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">众诚保险公众号系</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">由</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">众诚保险</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">运营的官方</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">公众号</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">。《</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">众诚保险公众号</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">个人信息保护政策》（</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">以下简称</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">本政策）旨在向您介绍</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">众诚保险公众号</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">处理您的个人信息的目的、方式和范围，以及您如何行使您享有的基于个人信息保护的权利。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">本政策适用于众诚保险公众号所提供的各项功能及服务，</font>
				</span></b><b style="mso-bidi-font-weight:normal"><span style="mso-spacerun:'yes';font-family:宋体;mso-ansi-font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">包括保险金融、个人账户基础功能。</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">您知悉并认可。</font>
			</span><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">此外，众诚保险公众号中可能存在部分功能或者服务由我们的关联公司、第三方合作伙伴提供，这些功能或者服务将适用单独的服务协议或者隐私政策，并将在您使用这些功能或者服务前单独向您告知。
					</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<o:p></o:p>
				</span></b></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">联系方式：</font>4008600600
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">联系地址</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">：广东省广州市</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">广州</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">大道中</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">998号1</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">3</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">楼</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">（运营机构同该地址）</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">本政策将帮助您了解以下内容：</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">1.定义、声明和承诺</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">2.我们如何收集和使用您的个人信息</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">3.我们如何使用Cookie和同类技术</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">4.我们如何委托处理、共享、转让、公开披露您的个人信息</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">5.我们如何存储和保护您的个人信息</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">6.您可以如何行使您的个人信息权利</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">7.我们如何保护未成年人的个人信息</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">8.本政策如何更新</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">9.如何联系我们</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">一、</font>&nbsp;定义、声明和承诺
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">请您在开始使用众诚保险公众号前，仔细阅读并确保您已经完全理解本政策，尤其是以下特别声明内容</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">；如果您不同意本政策的全部内容，请不要进行后续操作并提供您的任何个人信息。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">（一）众诚保险公众号不面向未满</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">十八</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">周岁的未成年人提供产品或者服务。</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">故请您确认，在您同意接受本政策并申请开通相关业务功能时，您已经是具有完全民事权利能力和完全民事行为能力、能够独立承担民事责任的自然人。如不具备前述条件，您应该立即停止申请使用本服务。
				</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">（二）众诚保险公众号是一个提供包括保险等相关服务在内的</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">微信公众号</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">，我们将在本政策中依次向您说明每项功能可能收集的个人信息范围、收集目的、收集方式，以及拒绝提供个人信息可能导致的结果。请您知悉，</font>
			</span><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">除基础功能以外，用户拒绝提供各项功能实现所必要的对应信息时，仍然可以使用众诚保险公众号的其他功能。</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">（三）</font>
			</span><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">请您注意，您在使用众诚保险公众号过程中出于业务需求，如需向我们提供除您本人外其他任何人的个人信息，您应当确保我们在处理这些个人信息前，您已经获得了相关个人信息主体的同意。</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">（四）本政策中的以下名词具体含义为：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">&nbsp;
				&nbsp;“个人信息”：以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。本政策所指必要范围个人信息是指消费侧用户个人信息，而不包括服务供给侧用户个人信息。</span><span
				style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">&nbsp;
				&nbsp;“敏感个人信息”：一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。本政策所涉敏感个人信息将</span><b><u><span
						style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
text-decoration:underline;text-underline:single;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
						<font face="宋体">加粗下划线</font>
					</span></u></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">提示。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">&nbsp; &nbsp;“个人信息处理”：包括个人信息的收集、存储、使用、加工、传输、提供、公开、删除等。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">本政策中出现以上未定义的相关名词含义，除由特殊说明外，与《中华人民共和国个人信息保护法》等相关法律法规的含义保持一致。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">&nbsp;</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">二、</font>&nbsp;我们如何收集和使用您的个人信息
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">众诚保险公众号仅出于本政策所述的以下目的、范围和方式，收集和使用您的个人信息，具体而言：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">（</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">一</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">）为您提供保险金融相关服务</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">以下为您在使用众诚保险公众号保险金融相关功能时我们可能收集的个人信息及相应目的、用途。若您不提供相关信息，可能会导致部分功能无法正常使用或无法更好享受平台为您提供的服务。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<table class=MsoNormalTable border=1 cellspacing=0
			style="border-collapse:collapse;width:100.0000%;margin-left:4.6500pt;
border:none;mso-border-left-alt:0.7500pt outset windowtext;mso-border-top-alt:0.7500pt outset windowtext;
mso-border-right-alt:0.7500pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;mso-padding-alt:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;">
			<tr>
				<td valign=center style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:1.0000pt outset windowtext;mso-border-left-alt:0.7500pt outset windowtext;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:1.0000pt outset windowtext;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;
background:rgb(250,224,207);">
					<p class=MsoNormal align=center style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:center;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">功能模块</span></b><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
								<o:p></o:p>
							</span></b></p>
				</td>
				<td valign=center style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;mso-border-left-alt:none;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:1.0000pt outset windowtext;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;
background:rgb(250,224,207);">
					<p class=MsoNormal align=center style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:center;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">收集个人信息</span></b><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
								<o:p></o:p>
							</span></b></p>
				</td>
				<td valign=center style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;mso-border-left-alt:none;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:1.0000pt outset windowtext;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;
background:rgb(250,224,207);">
					<p class=MsoNormal align=center style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:center;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">用途</span></b><b><span style="font-family:宋体;font-weight:bold;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
								<o:p></o:p>
							</span></b></p>
				</td>
			</tr>
			<tr>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:1.0000pt outset windowtext;mso-border-left-alt:0.7500pt outset windowtext;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">车险</span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
				</td>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;mso-border-left-alt:none;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">1.姓名</span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">2.</span><b><u><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
text-decoration:underline;text-underline:single;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">身份证</span></u></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">或其他代表个人身份的证件号</span><b><u><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
text-decoration:underline;text-underline:single;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">（护照、军人证、居住证</span></u></b><b><u><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
text-decoration:underline;text-underline:single;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">、驾驶证等</span></u></b><b><u><span style="font-family:宋体;font-weight:bold;text-decoration:underline;
text-underline:single;font-size:12.0000pt;mso-font-kerning:0.0000pt;">）</span></u></b><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">3.手机号</span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">4.</span><b><u><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
text-decoration:underline;text-underline:single;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">人脸照片</span></u></b><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">5.</span><b><u><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
text-decoration:underline;text-underline:single;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">行驶证上的车辆信息</span></u></b><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">6.电子邮箱或邮寄地址</span><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<font face="宋体">7</font>
						</span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">.</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">银行账户信息</span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
				</td>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;mso-border-left-alt:none;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">&nbsp;</span><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">1.姓名、证件号、手机号、人脸照片用于确认投保人、被保人、车主的个人身份真实性</span><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">。</span><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">2.车辆信息用于确认标的，以完成承保。</span><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">3.电子邮箱或邮寄地址用于接收保单、条款相关的保险单证</span><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">。</span><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<font face="宋体">4</font>
						</span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">.</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">驾驶证、银行账户信息用于办理车险理赔手续，收取赔款。</span><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">&nbsp;</span><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
				</td>
			</tr>
			<tr>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:1.0000pt outset windowtext;mso-border-left-alt:0.7500pt outset windowtext;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">非车险产品</span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
				</td>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;mso-border-left-alt:none;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">个人姓名、生日、性别、家庭关系、住址、个人电话号码、电子邮件地址、</span><b><u><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
text-decoration:underline;text-underline:single;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">身份证、军官证、护照、面部识别特征</span></u></b><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">、</span><b><u><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
text-decoration:underline;text-underline:single;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">银行账户、房产信息、个人上网记录</span></u></b><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">、</span><b><u><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
text-decoration:underline;text-underline:single;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">个人位置信息</span></u></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">、联系人信息、个人健康生理信息：含个人因生病医治产生的相关记录，如病症、住院志、医嘱单、检验报告、 手术及麻醉记录、护理记录、用药记录、药物食物过敏信息、生育信息、以
							往病史、诊治情况、家族病史、现病史、传染病史，以及与个人身体健康状况相关的信息，如体重、身高、肺活量。</span><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
				</td>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;mso-border-left-alt:none;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">用于</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">投保非车险</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">产品</span><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">；</span><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
				</td>
			</tr>
			<tr>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:1.0000pt outset windowtext;mso-border-left-alt:0.7500pt outset windowtext;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">保单查询</span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
				</td>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;mso-border-left-alt:none;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">姓名、保单号</span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
				</td>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;mso-border-left-alt:none;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">通过投保人手机号验证码，验证投保人本人操作</span><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
				</td>
			</tr>
			<tr>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:1.0000pt outset windowtext;mso-border-left-alt:0.7500pt outset windowtext;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p>&nbsp;</o:p>
						</span></p>
				</td>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;mso-border-left-alt:none;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-left:10.0000pt;mso-layout-grid-align:none;text-autospace:none;
text-align:left;"><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p>&nbsp;</o:p>
						</span></p>
				</td>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;mso-border-left-alt:none;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p>&nbsp;</o:p>
						</span></p>
				</td>
			</tr>
			<tr>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:1.0000pt outset windowtext;mso-border-left-alt:0.7500pt outset windowtext;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">非车险理赔</span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
				</td>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;mso-border-left-alt:none;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-left:10.0000pt;mso-layout-grid-align:none;text-autospace:none;
text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">个人姓名、电话号码、身份证、个人因生病医治产生的相关记录，如病症、病历、用药清单、医嘱单、检验报告、</span><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">&nbsp;</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">手术及麻醉记录、护理记录、用药记录、医疗费发票</span><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
				</td>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;mso-border-left-alt:none;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">用于非车险理赔</span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
				</td>
			</tr>
			<tr>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:1.0000pt outset windowtext;mso-border-left-alt:0.7500pt outset windowtext;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">用户互动</span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
				</td>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;mso-border-left-alt:none;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">姓名</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">、电话、收件地址</span><span style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
				</td>
				<td valign=center
					style="padding:0.0000pt 0.0000pt 0.0000pt 0.0000pt ;border-left:none;mso-border-left-alt:none;
border-right:1.0000pt outset windowtext;mso-border-right-alt:0.7500pt outset windowtext;border-top:none;
mso-border-top-alt:0.7500pt outset windowtext;border-bottom:1.0000pt outset windowtext;mso-border-bottom-alt:0.7500pt outset windowtext;">
					<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">用于向互动活动中的中奖或入选用户寄送奖品或礼品</span><span
							style="font-family:宋体;font-size:12.0000pt;mso-font-kerning:0.0000pt;">
							<o:p></o:p>
						</span></p>
				</td>
			</tr>
		</table>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">&nbsp;</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">（</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">二</font>
				</span></b><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">）安全管理</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">在您使用众诚保险公众号浏览、搜索信息，或者接受我们提供的各项服务时，为保障我们向您提供的服务稳定运行，我们会收集您的个人设备相关信息，或者基于</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">金融机构反洗钱、</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">互联网反黑产、反欺诈等必要目的，协助我们履行</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">反洗钱、</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">网络与数据安全相关法律义务，记录网络运行状态并形成系统操作日志等。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">在前述情形下。我们可能收集的个人设备信息，包括</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">设备型号、操作系统、唯一设备标识符、登陆</font>
				<font face="宋体">IP地址、微信软件版本号、接入网络方式、类型和状态、网络质量数据、设备加速器（如重力感应设备）、操作日志、服务日志信息，</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">这些信息是为提供安全服务必要收集的信息。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">请您特别留意：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">1.&nbsp;&nbsp;凡是超出与“我们如何收集您的个人信息”条款声称目的具有直接或合理关联的范围使用您的个人信息，我们会再次向您告知并征得您的明示同意。</span><span
				style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">2.根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息而无需征求您的授权同意&nbsp;：</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">1）&nbsp;与个人信息控制者履行法律法规规定的义务相关的；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">2）&nbsp;与国家安全、国防安全直接相关的；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">3）&nbsp;与公共安全、公共卫生、重大公共利益直接相关的；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">4）&nbsp;与刑事侦查、起诉、审判和判决执行等直接相关的；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">5）&nbsp;出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">6）&nbsp;所涉及的个人信息是个人信息主体自行向社会公众公开的；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">7）&nbsp;根据个人信息主体要求签订和履行合同所必需的；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">8）&nbsp;从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">9）&nbsp;维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">10）</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">&nbsp;<font face="宋体">履行金融机构反洗钱法定义务以及</font></span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">保险销售行为可</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">回溯</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">管理</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">等监管要求的</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">法定义务</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">；</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">11）其他法律法规等规定的情形。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">公众号</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">公告、另行签署协议等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">&nbsp;</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">三、</font>&nbsp;我们如何使用Cookie和同类技术
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">为使您获得更轻松的访问体验，我们会在您的移动设备终端发送例如名为</font>
				<font face="宋体">
					Cookie的小数据文件以识别您的身份。我们向您发送此类文件是为了简化您重复输入信息以登录账户的步骤、存储您的偏好设置、帮助判断您的登录状态以及账户或数据安全，目的是向您提供最友好、最安全的服务。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p>&nbsp;</o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">我们不会将</font>
				<font face="宋体">
					Cookie用于本隐私政策所述目的之外的任何用途，我们发送给您的Cookie等文件是唯一的，它只能被众诚保险公众号服务器读取，您可根据自己的偏好管理或删除此类Cookie文件。您可以清除移动设备上保存的所有
					Cookie等文件，也有权接受或拒绝Cookie，但您可能因此无法完全体验我们某些便捷性和安全性的服务功能。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">&nbsp;</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">四、</font>&nbsp;我们如何委托处理、共享、转让、公开披露您的个人信息
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">（一）委托处理</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">众诚保险公众号中某些具体的模块或功能由外部供应商提供。我们会聘请服务提供商来协助我们提供客户支持服务。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">约</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">定，要求他们按照我们的要求、本个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">（二）共享</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">一般情况下，我们不会对外共享您的个人信息，但下列情况除外：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">1.</span><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">在获取明确同意下的提供</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">：获得您的单独同意后，我们会向您指定的第三方共享您授权范围内的信息。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">2.</span><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">在法定情形下的提供</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外提供您的个人信息。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">3.经您同意后与第三方公司提供：出于公司管理的需要，您的信息可能会提供给第三方公司。我们只会提供必要的个人信息，且受本政策所声明目的的约束。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">提供给第三方公司的信息可能包括</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">您</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">
					本人的身份信息、财产信息、账户信息、信用信息、交易信息、医疗健康信息、行踪轨迹信息、电子设备信息、电子设备操作日志及其他与您本人相关的信息。我们将在提供上述信息前通过页面弹窗的形式征得您的单独同意。为确保您个人信息的安全，第三方公司对上述信息负有保密义务，并尽最大努力采取各种措施保证信息安全。
				</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">4.</span><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">经您同意后与我们的授权合作伙伴提供</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">：</font>&nbsp;仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴共享。我们可能会与合作伙伴共享您的某些个人信息，以提供相应的客户服务和用户体验。
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">（三）转让</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情形除外：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">a)&nbsp;在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span
				style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">b)&nbsp;在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">（四）公开披露</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">我们将遵守相关法律法规，对您的个人信息予以保密。除非事先获得您的明确同意或授权，或依照法律规定所必需，我们不会公开披露您的个人信息，但以下情形除外：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">1.获得您明确、单独同意后；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">2.基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">3.公司为了维护自己合法权益而向用户提起诉讼或者仲裁时。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">另外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得个人信息主体的授权同意：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">a)与个人信息控制者履行法律法规规定的义务相关的；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">b)与国家安全、国防安全直接相关的；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">c)与公共安全、公共卫生、重大公共利益直接相关的；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">d)与刑事侦查、起诉、审判和判决执行等直接相关的；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">e)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">f)个人信息主体自行向社会公众公开的个人信息；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">g)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">h)其他法律法规等规定的情形。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">&nbsp;</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">五、</font>&nbsp;我们如何存储和保护您的个人信息
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">我们收集和产生的个人信息将存储在中华人民共和国境内。</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">我们仅在本政策所述目的所必需期间和法律法规及监管规定的时限内保存您的个人信息。例如：您登录时的账号、电话，在您未进行删除或账号注销的行为时，我们会保留相关信息，这是提供业务所必要的。当您进行
				</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">个人信息</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">删除</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">后，我们将立即删除相应信息，如进行</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">账号注销，我们将对您的个人信息进行匿名化处理。前述</font>
				“法律法规及监管规定的时限”，包括按照《个人信息保护法》《保险法》《网络安全法》《电子商务法》《保险销售行为可回溯管理暂行办法》等规定的法定期限进行保存。
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">我们的微信公众号通过了国家网络安全等级保护（三级）的测评和备案，同时建立了完善的信息安全管理体系，从人员管理、制度完善、产品设计、控制措施等多个方面有效保障您的信息安全。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、泄露、篡改或丢失。我们会采取合理可行的措施，保护您的个人信息：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">1）我们针对网络数据交换传输层提供S</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">SL</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">安全协议加密保护，对网页提供</font>
				<font face="宋体">HTTPS协议安全浏览方式，确保用户数据在传输过程中的安全；</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">2）通过采取加密技术对用户个人信息进行加密保存，确保数据的保密性；</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">3）我们会使用受信赖的保护机制防止数据遭到恶意攻击；</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">4）我们会采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用；</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">5）我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">但同时请您注意，互联网并非绝对安全的环境，而且电子邮件、即时通讯等与其他用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的信息安全。
				</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p>&nbsp;</o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">六、</font>&nbsp;您可以如何行使您的个人信息权利
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">&nbsp;（一）&nbsp;查阅、复制您的个人信息</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">您有权查阅您的个人信息，但法律法规规定的例外情况除外。您可以自行查阅您的个人信息，</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">您也可以随时在众诚保险公众号上咨询在线客服。我们将确保在</font>15天内响应您的访问请求。
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">对于您在使用我们的产品或服务过程中产生的其他个人信息需要访问或者复制的，您还</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">可以通过</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">本政策公布的方式联系我们。我们会根据本政策所列明的方式和期限响应您的请求。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">（二）更正、补充您的个人信息</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">当您发现我们处理的关于您的个人信息有误或者不完整时，您有权要求我们做出更正、补充。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">您可以通过</font>“（一）查阅、复制您的个人信息”中罗列的方式提出更正、补充申请。
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">如果您无法通过上述链接更正或者补充个人信息，您可以随时咨询众诚保险公众号在线客服，或拨打电话</font>4008600600专线，我们将在15天内响应您的更正请求。
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">（三）撤回或者改变您授权同意的范围</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">如我们基于您的同意处理您个人信息的，您有权要求撤回该同意或者要求改变我们此前获取同意的范围。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">（</font>1）您可以通过以下方式撤回对隐私政策的同意：
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">通过咨询众诚保险公众号在线客服，或拨打电话</font>4008600600专线，我们将在15天内响应您的更正请求
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">
					请您理解，由于各项功能和服务需要各自所对应的必要个人信息才能得以提供，当您撤回同意或者改变授权范围后，我们将无法继续为您提供撤回同意或改变授权范围所对应的功能和服务。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。
				</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">（四）注销账户</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">您随时可注销此前注册的账户，您可以通过以下方式自行操作：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">1、&nbsp;在线注销：通过众诚保险公众号</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">“个人中心”</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">“账号</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">解绑</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">”来注销您的</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">账户</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">；</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">2、&nbsp;拨打电话：拨打4008600600专线告知我们您的注销原因，我们将在15天内为您处理。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">在注销账户之后，我们将停止为您提供产品或服务，但您在使用众诚保险公众号服务期间提供或产生的信息，我们仍需按照监管要求的时间进行保存，且在该保存的时间内依法配合有权机关的监管、调查和问询。
				</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">（五）删除您的个人信息</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">有如下情形之一的，您可以通过本政策列明的联系方式，向我们提出删除个人信息的请求：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">1.&nbsp;如果处理目的已实现、无法实现或者为实现处理目的不再必要；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">2.&nbsp;如果我们停止提供产品或者服务，或者保存期限已届满（如您已经不再使用我们的产品或服务，或者您已经注销了账号）；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">3.如果您已经撤回同意；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">4.如果我们违反法律、行政法规或者违反约定处理您的个人信息；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">5.法律、行政法规规定的其他情形。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">
					我们将根据国家法律法规及监管的要求决定是否响应您的请求，若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">（六）获取个人信息副本</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">您有权获取您的个人信息副本。如您需要获取我们收集的您的个人信息副本，您可通过拨打人工客服热线</font>
				4008600600、在线客服会对您进行个人信息校验，完成姓名、电话、身份证后六位的个人信息主体确认后，将个人信息副本通过
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">微信公众号</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">在线客服提交给您。在符合相关法律规定且技术可行的前提下，我们将根据您的要求向您提供您的个人信息副本</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">（七）约束信息系统自动决策</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">
					在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。在进行自动化决策时，我们将确保决策的透明度和结果公平、公正，不会对您在交易价格等交易条件上实行不合理的差别待遇；在进行信息推送时，一并为您提供不针对个人特征的选项和拒绝方式。（实现路径请参见
				</font>“个性化推荐”）。如果您认为自动化决策结果显著影响了您的合法权益，您有权通过本政策列明的联系方式要求我们做出解释，并有权拒绝我们仅通过自动化决策的方式作出决定。
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">（八）对账户信息的生前安排</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">
					根据相关法律要求，您可以提前就您的个人信息提前进行生前安排，您可以通过本政策公布的联系方式，通过书面方式告知我们您的安排；如无另行安排，您的近亲属可以基于其合法、正当利益，对您生后的相关个人信息依照相关法律规定和本政策的约定，行使查阅、复制、更正、删除等权利。
				</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">（九）响应您的上述请求</font>
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">我们将在</font>15天内做出答复。如您不满意，还可以通过以下途径投诉：&nbsp;拨打电话4008600600专线或者选择众诚保险公众号上在线客服。
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">
					对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。
				</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">请您知悉，在以下情形中，按照法律法规要求，我们将无法响应您的请求：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">1.与国家安全、国防安全直接相关的；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">2.与公共安全、公共卫生、重大公共利益直接相关的；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">3.与犯罪侦查、起诉、审判和判决执行等直接相关的；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">4.有充分证据表明您存在主观恶意或滥用权利的；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">5.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">6.涉及商业秘密的。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">七、</font>&nbsp;共享条款
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">
					为了进一步提升您的用户体验，或是为了向您提供更为智能化、个性化的服务。我们可能会与关联方共享您的个人信息。我们会在开启相关业务功能之前单独征求您的同意，您可以自主选择是否授权我们进行该等共享，或联系我们取消授权。如果您拒绝授权该等业务功能，并不会影响您使用其它功能或服务。
				</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">以下为相关业务功能的具体描述：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span
				style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">1.改善产品与提升服务：为了向您提供有温度的金融服务，我们将依据您金融支付、医疗健康、衣食住行不同场景的实际需求，持续改善您的产品体验，我们共享您主动提供、使用服务中产生的相关信息，用于相关产品的持续优化与改善，产品包括汽车</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">保险</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">服务生态圈产品，例如，通过对客户开展群体分析，作为开发新产品、下架旧产品、调整服务方式的参考。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span
				style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">2.市场调研：我们可能对产品或服务、以及其他类似的产品或服务进行市场调研并共享相关信息，从而了解您对产品或服务的需求、偏好与建议。例如，我们可能向您发送调研问卷，邀请您参与反馈。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">内容推荐：我们可能共享您的个人信息、特征标签或用户画像，从而向您推荐您可能感兴趣的资讯、活动或其他内容，便于您了解相关信息。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">3.营销推广：我们可能共享您的个人信息、特征标签或用户画像，从而向您发送您可能感兴趣的营销活动通知、商业性信息等内容，推广我们的产品或服务。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">
					在共享您的个人信息之前以及共享的过程中，我们将充分评估该等共享的合法性、正当性、必要性，并采用适当的管理措施与技术措施，以保障您的个人信息安全。关联公司如果想要改变本隐私政策声明的个人信息使用目的，将再次征求您的授权同意。
				</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">除了取得您的同意的情形，我们还会在法律法规允许的范围内共享您的个人信息，包括：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">1.为订立或者履行个人作为一方当事人的合同所必需；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">2.为履行法定职责或者法定义务所必需；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">3.为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">4.依法在合理的范围内处理已公开的个人信息；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">5.为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">法律、行政法规规定的其他情形。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">八、</font>&nbsp;我们如何保护未成年人的个人信息
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">我们重视未成年人的个人信息保护。请您知悉，通常情况下，我们不面向未满十</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">八</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">
					周岁的未成年人提供产品和服务。除非您提交的实人认证信息或者结合其他信息（如浏览、搜索记录等）可以识别出您为未成年人的情形外，我们将根据商业惯例，推定您具有相应的民事行为能力。如您为已满十四周岁但未满十八周岁的未成年人，请您和您的父母或其他监护人共同仔细阅读本政策，并在征得您的父母或其他监护人同意监督的前提下使用我们的服务或向我们提供信息。
				</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">
					根据《儿童个人信息网络保护规定》以及相关可适用的法律法规，如果我们识别出您是不满十四周岁的儿童用户的，我们将通知您的父母或者监护人并只有经其同意后才允许您继续使用我们的产品或服务。当我们未和您的父母或者监护人取得联系或者其不同意我们关于儿童个人信息收集使用规则的，我们将尽快删除相关数据。对于经父母或其他监护人同意使用我们的产品或服务而收集儿童个人信息的情况，我们只会在法律法规允许、父母或其他监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。
				</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">若您是未成年人的父母或其他监护人，请您关注您监护的未成年人是否是在取得您的授权同意之后使用我们的服务的。如您对您所监护的未成年人的个人信息有疑问，请通过本政策中公布的联系方式与我们联系。
				</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">九、</font>&nbsp;本政策如何更新
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">我们的隐私政策可能变更。未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">本政策所指的重大变更包括但不限于：</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">2.我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">3.个人信息共享或公开披露的主要对象发生变化。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">4.您参与个人信息处理方面的权利及其行使方式发生重大变化。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">5.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">6.个人信息安全影响评估报告表明存在高风险时。</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">由于我们的用户较多，如本政策发生除上述重大变更之外的其他更新，我们将</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">以</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">弹窗提示的形式向您展示变更后的指引。</font>
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-bottom:5.0000pt;mso-margin-top-alt:auto;
mso-margin-bottom-alt:auto;mso-pagination:widow-orphan;text-align:left;"><b><span style="mso-spacerun:'yes';font-family:宋体;font-weight:bold;
font-size:12.0000pt;mso-font-kerning:0.0000pt;">
					<font face="宋体">十、</font>&nbsp;如何联系我们
				</span></b><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal style="margin-top:5.0000pt;margin-right:-9.8500pt;margin-bottom:5.0000pt;
mso-para-margin-right:-0.9400gd;mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
mso-pagination:widow-orphan;text-align:left;"><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<font face="宋体">如果您对本政策有任何疑问、意见或建议，通过众诚保险公众号在线客服，或者通过拨打</font>4008600600专线与我们联系，一般情况下，我们将在15天内回复。
			</span><span style="mso-spacerun:'yes';font-family:宋体;font-size:12.0000pt;
mso-font-kerning:0.0000pt;">
				<o:p></o:p>
			</span></p>
		<p class=MsoNormal><span style="mso-spacerun:'yes';font-family:Calibri;mso-fareast-font-family:宋体;
mso-bidi-font-family:'Times New Roman';font-size:10.5000pt;mso-font-kerning:1.0000pt;">
				<o:p>&nbsp;</o:p>
			</span></p>
	</div>
	</div>
</template>

<script>
// 此页面为 word 文档导出页面
export default {
  data() {
    return {

    };
  },
  async mounted() {

  },
  methods: {
  }
};
</script>

<style lang="scss">
		@font-face {
			font-family: "Times New Roman";
		}

		@font-face {
			font-family: "宋体";
		}

		@font-face {
			font-family: "Calibri";
		}

		@font-face {
			font-family: "Wingdings";
		}

		p.MsoNormal {
			mso-style-name: 正文;
			mso-style-parent: "";
			margin: 0pt;
			margin-bottom: .0001pt;
			mso-pagination: none;
			text-align: justify;
			text-justify: inter-ideograph;
			font-family: Calibri;
			mso-fareast-font-family: 宋体;
			mso-bidi-font-family: 'Times New Roman';
			font-size: 10.5000pt;
			mso-font-kerning: 1.0000pt;
		}

		span.10 {
			font-family: Calibri;
		}

		span.15 {
			font-family: Calibri;
			font-weight: bold;
		}

		span.16 {
			font-family: Calibri;
			font-size: 9.0000pt;
		}

		span.17 {
			font-family: Calibri;
			font-size: 10.5000pt;
		}

		span.18 {
			font-family: Calibri;
			font-size: 9.0000pt;
		}

		span.19 {
			font-family: Calibri;
		}

		span.20 {
			font-family: Calibri;
			font-size: 9.0000pt;
		}

		p.MsoCommentSubject {
			mso-style-name: 批注主题;
			mso-style-noshow: yes;
			mso-style-parent: 批注文字;
			mso-style-next: 批注文字;
			margin: 0pt;
			margin-bottom: .0001pt;
			mso-pagination: none;
			text-align: left;
			font-family: Calibri;
			mso-fareast-font-family: 宋体;
			mso-bidi-font-family: 'Times New Roman';
			font-weight: bold;
			font-size: 10.5000pt;
			mso-font-kerning: 1.0000pt;
		}

		p.MsoHeader {
			mso-style-name: 页眉;
			mso-style-noshow: yes;
			margin: 0pt;
			margin-bottom: .0001pt;
			border-bottom: 1.0000pt solid windowtext;
			mso-border-bottom-alt: 0.7500pt solid windowtext;
			padding: 0pt 0pt 1pt 0pt;
			layout-grid-mode: char;
			mso-pagination: none;
			text-align: center;
			font-family: Calibri;
			mso-fareast-font-family: 宋体;
			mso-bidi-font-family: 'Times New Roman';
			font-size: 9.0000pt;
			mso-font-kerning: 1.0000pt;
		}

		p.MsoCommentText {
			mso-style-name: 批注文字;
			mso-style-noshow: yes;
			margin: 0pt;
			margin-bottom: .0001pt;
			mso-pagination: none;
			text-align: left;
			font-family: Calibri;
			mso-fareast-font-family: 宋体;
			mso-bidi-font-family: 'Times New Roman';
			font-size: 10.5000pt;
			mso-font-kerning: 1.0000pt;
		}

		p.MsoAcetate {
			mso-style-name: 批注框文本;
			mso-style-noshow: yes;
			margin: 0pt;
			margin-bottom: .0001pt;
			mso-pagination: none;
			text-align: justify;
			text-justify: inter-ideograph;
			font-family: Calibri;
			mso-fareast-font-family: 宋体;
			mso-bidi-font-family: 'Times New Roman';
			font-size: 9.0000pt;
			mso-font-kerning: 1.0000pt;
		}

		p.MsoFooter {
			mso-style-name: 页脚;
			mso-style-noshow: yes;
			margin: 0pt;
			margin-bottom: .0001pt;
			layout-grid-mode: char;
			mso-pagination: none;
			text-align: left;
			font-family: Calibri;
			mso-fareast-font-family: 宋体;
			mso-bidi-font-family: 'Times New Roman';
			font-size: 9.0000pt;
			mso-font-kerning: 1.0000pt;
		}

		p.p {
			mso-style-name: "普通\(网站\)";
			mso-style-noshow: yes;
			margin-top: 5.0000pt;
			margin-bottom: 5.0000pt;
			mso-margin-top-alt: auto;
			mso-margin-bottom-alt: auto;
			mso-pagination: widow-orphan;
			text-align: left;
			font-family: 宋体;
			font-size: 12.0000pt;
		}

		p.27 {
			mso-style-name: "List Paragraph";
			margin: 0pt;
			margin-bottom: .0001pt;
			text-indent: 21.0000pt;
			mso-pagination: widow-orphan;
			text-align: left;
			font-family: 宋体;
			font-size: 12.0000pt;
		}

		span.msoIns {
			mso-style-type: export-only;
			mso-style-name: "";
			text-decoration: underline;
			text-underline: single;
			color: blue;
		}

		span.msoDel {
			mso-style-type: export-only;
			mso-style-name: "";
			text-decoration: line-through;
			color: red;
		}

		table.MsoNormalTable {
			mso-style-name: 普通表格;
			mso-style-parent: "";
			mso-style-noshow: yes;
			mso-tstyle-rowband-size: 0;
			mso-tstyle-colband-size: 0;
			mso-padding-alt: 0.0000pt 5.4000pt 0.0000pt 5.4000pt;
			mso-para-margin: 0pt;
			mso-para-margin-bottom: .0001pt;
			mso-pagination: widow-orphan;
			font-family: 'Times New Roman';
			font-size: 10.0000pt;
			mso-ansi-language: #0400;
			mso-fareast-language: #0400;
			mso-bidi-language: #0400;
		}

		@page {
			mso-page-border-surround-header: no;
			mso-page-border-surround-footer: no;
		}

		@page Section0 {
			margin-top: 72.0000pt;
			margin-bottom: 72.0000pt;
			margin-left: 90.0000pt;
			margin-right: 90.0000pt;
			size: 595.3000pt 841.9000pt;
			layout-grid: 15.6000pt;
			mso-header-margin: 42.5500pt;
			mso-footer-margin: 49.6000pt;
		}

		div.Section0 {
			page: Section0;
		}
	</style>
